import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { H3, P, Div, Section } from 'components/Ui';
import { getRegionalBrandName } from 'utils/domainHelper';
import { translateData } from 'utils/translation';
import { domainMap, COSTCO_WATER_SLUG } from 'containers/Landing/constants';
import { envIcon, noteIcon, heartIcon } from 'images';
import { isSsr } from 'utils/ssrHelper';
import ChangePasswordForm from 'components/Forms/ChangePasswordForm';
import ConversionTag from 'containers/PrimoCheckoutPage/ConversionTag';
import styles from './styles.scss';

const SubHeader = ({
  order,
  subtitle,
  title,
  notes,
  additionalNote,
  confirmationNumber,
}) => {
  const translatedTitle = translateData(title);

  let whatHappensNext = null;
  let showWhatHappensNext = true;
  let showChangePassword = false;

  let line1 = null;
  let line2 = null;
  let line3 = null;

  if (!isSsr() && confirmationNumber) {
    const accountManagementNumber = translateData(
      'accountManagementNumber',
      `DT:800-728-5508`,
    );

    const emailAddress = get(order, 'delivery.email', '');

    // let theOrder = order;
    // if (window.PrimoTestOrder) {
    //   theOrder = { ...order, ...window.PrimoTestOrder };
    //   // eslint-disable-next-line no-console
    //   console.log('ZZZ ~ order', order);
    //   // eslint-disable-next-line no-console
    //   console.log('ZZZ ~ theOrder', theOrder);
    // }

    const userExists = get(order, 'userExists', false);
    const userCreated = get(order, 'userCreated', true);
    const customerCreated = get(order, 'customerCreated', true);

    if (userExists) {
      // 3. Order confirmed, Account already exists
      // if (window.PrimoTestOrder) {
      //   // eslint-disable-next-line no-console
      //   console.log('ZZZ ~ In 3. Order confirmed, Account already exists');
      // }
      showChangePassword = false;
      showWhatHappensNext = false;
      // Below setup the messages to be displayed
      const niceWork = translateData(
        'niceWork',
        `DT:Nice work! And we see you already have an account with your email address`,
      );
      line1 = (
        <div className={styles.line1}>{`${niceWork} ${emailAddress}.`}</div>
      );
      const linkAccount = translateData(
        'linkAccount',
        `DT:We have linked that address with this new account. Please use your existing password to manage your service`,
      );
      line2 = <div className={styles.line2}>{linkAccount}.</div>;
    } else if (customerCreated && userCreated) {
      // Happy path
      // 1. Order Confirmed, Set Password
      // if (window.PrimoTestOrder) {
      //   // eslint-disable-next-line no-console
      //   console.log('ZZZ ~ In 1. Order Confirmed, Set Password');
      // }
      showChangePassword = true;
      // Below setup the messages to be displayed
      const createPassword = translateData(
        'createPassword',
        `DT:Nice work! The only thing left is to create a password for your account so you can easily manage your orders and payments at any time.`,
      );
      line1 = <div className={styles.line1}>{createPassword}</div>;
      line2 = null;
    } else {
      // 2. Order Confirmed, Issue with Account Creation
      // if (window.PrimoTestOrder) {
      //   // eslint-disable-next-line no-console
      //   console.log('ZZZ ~ In 1. 2. Order Confirmed, Issue with Account Creation');
      // }
      showChangePassword = false;
      showWhatHappensNext = false;
      // Below setup the messages to be displayed
      const errorCreatingAccount = translateData(
        'errorCreatingAccount',
        `DT:Your order is complete, but an error occurred while creating your online account.`,
      );
      line1 = <div className={styles.line1}>{errorCreatingAccount}</div>;
      const manageYourOrders = translateData(
        'manageYourOrders',
        `DT:To ensure you can easily manage your orders and payments at any time, please call us at`,
      );
      const href = (
        <a href={`tel:+${accountManagementNumber}`}>
          {accountManagementNumber}
        </a>
      );
      line2 = (
        <div className={styles.line2}>
          {manageYourOrders} {href}.
        </div>
      );
    }

    const confirmationEmail = translateData(
      'confirmationEmail',
      `DT:For your convenience, a confirmation will also be sent to your email address.`,
    );
    line3 = <div className={styles.line3}>{confirmationEmail}</div>;

    const showSetUpYourAccount = false;

    whatHappensNext = (
      <div className={styles.whnContainer}>
        <H3 className={styles.whnHeader}>Here’s what happens next:</H3>
        <div className={styles.whnContent}>
          <div className={styles.whnNextContainer}>
            <img
              className={styles.whnImage}
              src={envIcon}
              alt=""
              aria-hidden="true"
            />
            <Div className={styles.whnTitle}>Check your email</Div>
            <Div className={styles.whnSubtitle}>
              We’ll be sending you a confirmation email. Once you receive it,
              click through to complete the process and get your hydration on.
            </Div>
          </div>
          {showSetUpYourAccount && (
            <div className={styles.whnNextContainer}>
              <img
                className={styles.whnImage}
                src={noteIcon}
                alt=""
                aria-hidden="true"
              />
              <Div className={styles.whnTitle}>Set up your account</Div>
              <Div className={styles.whnSubtitle}>
                Make sure to enter all your details so you have easy access and
                complete control of your account, anytime and anywhere.
              </Div>
            </div>
          )}
          <div className={styles.whnNextContainer}>
            <img
              className={styles.whnImage}
              src={heartIcon}
              alt=""
              aria-hidden="true"
            />
            <Div className={styles.whnTitle}>Enjoy your new account</Div>
            <Div className={styles.whnSubtitle}>
              Modify deliveries, search for new items, set your order type, and
              even leave instructions for your Route Sales Representative
              through your online account.
            </Div>
          </div>
        </div>
      </div>
    );
  }

  let siteName;
  if (window.isCostcoWater) {
    const waterBrand = `costcowater-${get(window, 'brandByZip', '').replace(
      /-/g,
      '',
    )}`;
    const domain = domainMap[waterBrand]
      ? domainMap[waterBrand]
      : domainMap[COSTCO_WATER_SLUG];

    siteName = domain.name;
  } else {
    siteName = getRegionalBrandName(null, 9);
  }

  return (
    <Section className={styles.subHeader} aria-label={translatedTitle}>
      <hgroup className={styles.headerGroupText}>
        {subtitle && <P className={styles.subtitle}>{subtitle}</P>}
        <h2 className={styles.title} style={{ maxWidth: '800px' }}>
          {translatedTitle.replace('{site-name}', siteName)}
        </h2>
      </hgroup>
      <div className={styles.note} role="group">
        {notes.map((note) => (
          <span key={note}>
            {translateData(note).replace('{site-name}', siteName)}
          </span>
        ))}
        {translateData(additionalNote)}
        {line1}
        {line2}
        {line3}
      </div>
      {confirmationNumber && (
        <>
          <P className={styles.confirmationNumber}>
            {translateData('Confirmation Number:')}{' '}
            <span>{confirmationNumber}</span>
          </P>
          <ConversionTag
            name="sfmc.tracking"
            action="conversion"
            traceId={confirmationNumber}
            dataset={order.items}
            email={order.delivery.email}
          ></ConversionTag>
        </>
      )}
      {showChangePassword && <ChangePasswordForm />}
      {showWhatHappensNext && whatHappensNext}
    </Section>
  );
};

SubHeader.propTypes = {
  order: PropTypes.object.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  notes: PropTypes.arrayOf(PropTypes.string).isRequired,
  additionalNote: PropTypes.string,
  confirmationNumber: PropTypes.string,
};

export default SubHeader;
